import React from 'react';
import styles from './Loading.module.less';
import { CircularProgress } from 'edcom-ui';

export default function Loading() {
  return (
    <div className={styles.loading}>
      <CircularProgress size={100} thickness={5} />
    </div>
  );
}
